import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { iosAppUrlSelector, androidAppUrlSelector } from 'settings/selectors'

import AppStore from '../../icons/ic-appstore.svg'
import GooglePlay from '../../icons/ic-googleplay.svg'

import { appStoreBadgeUrlSelector, googlePlayBadgeUrlSelector } from '../../../wordpress/selectors'

const Badge = defaultBadge => {
    const component = ({ containerClass, linkClass, imgClass, downloadUrl, badge, children }) => {
        const Image = () => <img className={imgClass} src={badge || defaultBadge} />
        return (
            <a href={downloadUrl} className={linkClass} target="_blank">
                {children ? (
                    <div className={containerClass}>
                        {children}
                        <Image />
                    </div>
                ) : (
                    <Image />
                )}
            </a>
        )
    }

    return component
}

export const AppStoreBadge = connect(
    createStructuredSelector({
        downloadUrl: iosAppUrlSelector,
        badge: appStoreBadgeUrlSelector,
    })
)(Badge(AppStore))

export const GooglePlayStoreBadge = connect(
    createStructuredSelector({
        downloadUrl: androidAppUrlSelector,
        badge: googlePlayBadgeUrlSelector,
    })
)(Badge(GooglePlay))
